import { getCollectionActionTypes } from '@framework/state/Redux/collectionFactory';

export const keyWord = 'LEAGUE_TABLE_UNDERWRITERS';

export default getCollectionActionTypes(keyWord);
